import apiClient from '../api/apiClient';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const sellRequestService = {
  getAdminSellRequests: async (params = {}) => {
    const defaultParams = {
      page: 1,
      limit: 10,
      ...params,
    };
    const response = await apiClient.get('/api/v1/sell-requests/admin', { params: defaultParams });
    return unwrap(response);
  },
};

export default sellRequestService;
